import React, { useState } from 'react';
import { PaystackScript } from '../components/Payment/PaystackScript';
import { Check, Star, TrendingUp, Zap } from 'lucide-react';
import { Link } from 'react-router-dom';
export const AIPowerBundle = () => {
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState<'pending' | 'form' | 'success'>('pending');
  const [reference, setReference] = useState('');
  const [formStep, setFormStep] = useState(1);
  const [formData, setFormData] = useState({
    // Page 1
    fullName: '',
    email: '',
    phone: '',
    profession: '',
    cityState: '',
    hasCreatedWebsite: '',
    aiComfortLevel: '',
    device: [] as string[],
    learningGoal: [] as string[],
    biggestFrustration: [] as string[],
    oneThingToWalkAway: '',
    // Page 2
    interestInMasterclass: '',
    priceWillingness: '',
    investmentFactor: [] as string[],
    monetizationIntent: '',
    audienceToServe: [] as string[],
    monthlyIncomeGoal: '',
    preferredClassStyle: '',
    preferredClassTime: [] as string[],
    practicePreference: [] as string[],
    paymentPlanHelp: '',
    permissionForUpdates: ''
  });
  const handlePaymentSuccess = (ref: string) => {
    setReference(ref);
    setPaymentStatus('form');
    window.scrollTo(0, 0);
  };
  const handleFormChange = (e: any) => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    if (type === 'checkbox') {
      setFormData(prev => {
        const currentArray = prev[name as keyof typeof prev] as string[];
        if (checked) {
          return {
            ...prev,
            [name]: [...currentArray, value]
          };
        } else {
          return {
            ...prev,
            [name]: currentArray.filter(item => item !== value)
          };
        }
      });
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };
  const handleNextStep = () => {
    setFormStep(2);
    window.scrollTo(0, 0);
  };
  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const data = {
      fullName: formData.fullName,
      email: formData.email,
      phone: formData.phone,
      profession: formData.profession,
      city: formData.cityState,
      websiteExperience: formData.hasCreatedWebsite,
      aiComfort: formData.aiComfortLevel,
      device: Array.isArray(formData.device) ? formData.device.join(', ') : formData.device,
      goal: Array.isArray(formData.learningGoal) ? formData.learningGoal.join(', ') : formData.learningGoal,
      frustration: Array.isArray(formData.biggestFrustration) ? formData.biggestFrustration.join(', ') : formData.biggestFrustration,
      oneThing: formData.oneThingToWalkAway,
      masterclassInterest: formData.interestInMasterclass,
      priceRange: formData.priceWillingness,
      investTrigger: Array.isArray(formData.investmentFactor) ? formData.investmentFactor.join(', ') : formData.investmentFactor,
      monetize: formData.monetizationIntent,
      audience: Array.isArray(formData.audienceToServe) ? formData.audienceToServe.join(', ') : formData.audienceToServe,
      monthlyGoal: formData.monthlyIncomeGoal,
      classStyle: formData.preferredClassStyle,
      classTime: Array.isArray(formData.preferredClassTime) ? formData.preferredClassTime.join(', ') : formData.preferredClassTime,
      practicePreference: Array.isArray(formData.practicePreference) ? formData.practicePreference.join(', ') : formData.practicePreference,
      paymentPlan: formData.paymentPlanHelp,
      permission: formData.permissionForUpdates
    };
    try {
      const response = await fetch('https://script.google.com/macros/s/AKfycbx3X11ZnhJ9Qas0Ylp8l7U1OHsjyTtx-u-Zp-mhsA3blmP3aIJBhB4TfhcLmnSFAgtg5A/exec', {
        method: 'POST',
        body: JSON.stringify(data)
      });
      const result = await response.json();
      if (result.result === 'success') {
        setPaymentStatus('success');
        window.location.href = 'https://chat.whatsapp.com/KuVilCGv5Zn8KqDmdOUoee';
      } else {
        alert('Submission failed. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Submission failed. Please try again.');
    }
  };
  const initializePayment = () => {
    if (!(window as any).PaystackPop) {
      alert('Payment system loading, please try again in a moment');
      return;
    }
    const handler = (window as any).PaystackPop.setup({
      key: 'pk_live_c2f71547b29d95243a012d9ef2f8e03485d942e7',
      email: 'customer@email.com',
      amount: 5000 * 100,
      currency: 'NGN',
      callback: (response: any) => {
        handlePaymentSuccess(response.reference);
      },
      onClose: () => {
        console.log('Payment closed');
      }
    });
    handler.openIframe();
  };
  if (paymentStatus === 'success') {
    return <div className="min-h-screen flex items-center justify-center" style={{
      backgroundColor: '#F9F9F9'
    }} data-id="element-2209">
        <div className="text-center p-8" data-id="element-2210">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full flex items-center justify-center" style={{
          backgroundColor: '#1AB9C8'
        }} data-id="element-2211">
            <Check size={40} style={{
            color: '#FFFFFF'
          }} data-id="element-2212" />
          </div>
          <h1 className="text-3xl font-bold mb-4" style={{
          color: '#0B1F3F'
        }} data-id="element-2213">
            Redirecting to WhatsApp...
          </h1>
          <p style={{
          color: '#333333'
        }} data-id="element-2214">
            Your ebook will be delivered shortly!
          </p>
        </div>
      </div>;
  }
  if (paymentStatus === 'form') {
    return <div className="min-h-screen py-12" style={{
      backgroundColor: '#F9F9F9'
    }} data-id="element-2215">
        <div className="container mx-auto px-4 max-w-3xl" data-id="element-2216">
          <div className="mb-8 text-center" data-id="element-2217">
            <h1 className="text-3xl font-bold mb-4" style={{
            color: '#0B1F3F'
          }} data-id="element-2218">
              Almost There! Let's Get You Set Up
            </h1>
            <p className="text-lg" style={{
            color: '#333333'
          }} data-id="element-2219">
              Fill this short form so we know a bit about you and can deliver
              your ebook straight to your WhatsApp
            </p>
          </div>

          {/* Progress Bar */}
          <div className="mb-8" data-id="element-2220">
            <div className="h-2 rounded-full" style={{
            backgroundColor: '#E5E5E5'
          }} data-id="element-2221">
              <div className="h-full rounded-full transition-all duration-300" style={{
              backgroundColor: '#F4B400',
              width: formStep === 1 ? '50%' : '100%'
            }} data-id="element-2222" />
            </div>
            <p className="text-center mt-2 text-sm" style={{
            color: '#333333'
          }} data-id="element-2223">
              Step {formStep} of 2
            </p>
          </div>

          <form id="aiForm" onSubmit={formStep === 2 ? handleFormSubmit : e => {
          e.preventDefault();
          handleNextStep();
        }} className="space-y-6 p-8 rounded-lg" style={{
          backgroundColor: '#FFFFFF',
          border: '2px solid #E5E5E5'
        }} data-id="element-2224">
            {formStep === 1 ? <>
                <h2 className="text-2xl font-bold mb-6" style={{
              color: '#0B1F3F'
            }} data-id="element-2225">
                  Basic Info & Digital Readiness
                </h2>

                <div data-id="element-2226">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2227">
                    Full Name *
                  </label>
                  <input type="text" name="fullName" value={formData.fullName} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2228" />
                </div>

                <div data-id="element-2229">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2230">
                    Email Address *
                  </label>
                  <input type="email" name="email" value={formData.email} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2231" />
                </div>

                <div data-id="element-2232">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2233">
                    Phone Number *
                  </label>
                  <input type="tel" name="phone" value={formData.phone} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2234" />
                </div>

                <div data-id="element-2235">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2236">
                    Current Profession *
                  </label>
                  <input type="text" name="profession" value={formData.profession} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2237" />
                </div>

                <div data-id="element-2238">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2239">
                    City/State *
                  </label>
                  <input type="text" name="cityState" value={formData.cityState} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2240" />
                </div>

                <div data-id="element-2241">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2242">
                    Have you ever created a website before? *
                  </label>
                  <select name="hasCreatedWebsite" value={formData.hasCreatedWebsite} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2243">
                    <option value="" data-id="element-2244">Select...</option>
                    <option value="Yes" data-id="element-2245">Yes</option>
                    <option value="No" data-id="element-2246">No</option>
                  </select>
                </div>

                <div data-id="element-2247">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2248">
                    Comfort level with AI tools *
                  </label>
                  <select name="aiComfortLevel" value={formData.aiComfortLevel} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2249">
                    <option value="" data-id="element-2250">Select...</option>
                    <option value="Beginner" data-id="element-2251">Beginner</option>
                    <option value="Intermediate" data-id="element-2252">Intermediate</option>
                    <option value="Advanced" data-id="element-2253">Advanced</option>
                  </select>
                </div>

                <div data-id="element-2254">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2255">
                    Device you work with? * (Select all that apply)
                  </label>
                  <div className="space-y-2" data-id="element-2256">
                    {['Laptop (Windows)', 'Laptop (Mac)', 'Desktop Computer', 'Tablet', 'Smartphone Only', 'Smartphone + occasional laptop access', 'I currently have no device'].map(option => <label key={option} className="flex items-center" data-id="element-2257">
                        <input type="checkbox" name="device" value={option} checked={formData.device.includes(option)} onChange={handleFormChange} className="mr-2" data-id="element-2258" />
                        <span style={{
                    color: '#333333'
                  }} data-id="element-2259">
                          {option}
                        </span>
                      </label>)}
                  </div>
                </div>

                <div data-id="element-2260">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2261">
                    What exactly do you want to achieve with this AI Skills
                    Class? * (Choose one or multiple)
                  </label>
                  <div className="space-y-2" data-id="element-2262">
                    {['Learn how to use AI for everyday productivity', 'Automate repetitive tasks in my work/business', 'Learn how to use AI tools for content creation', 'Build AI-powered workflows (emails, proposals, research, etc.)', 'Create digital products/services using AI', 'Improve my career or become more employable', 'Start a freelance or consulting business using AI', 'Learn how to train or specialize AI for my field', 'Understand AI well enough to teach others', 'Not sure yet — I just want to learn'].map(option => <label key={option} className="flex items-center" data-id="element-2263">
                        <input type="checkbox" name="learningGoal" value={option} checked={formData.learningGoal.includes(option)} onChange={handleFormChange} className="mr-2" data-id="element-2264" />
                        <span style={{
                    color: '#333333'
                  }} data-id="element-2265">
                          {option}
                        </span>
                      </label>)}
                  </div>
                </div>

                <div data-id="element-2266">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2267">
                    Biggest frustration with learning digital skills? * (Select
                    up to 4)
                  </label>
                  <div className="space-y-2" data-id="element-2268">
                    {["Too much information — I don't know where to start", 'No one to guide me step-by-step', "I learn but I can't apply it practically", "I don't have enough time", 'Tools feel too complex', 'Training programs are too expensive', 'I learn fast but forget when I try to do it alone', 'My device is slow or limited', 'Poor internet connection', "I'm overwhelmed… everything feels new"].map(option => <label key={option} className="flex items-center" data-id="element-2269">
                        <input type="checkbox" name="biggestFrustration" value={option} checked={formData.biggestFrustration.includes(option)} onChange={handleFormChange} disabled={formData.biggestFrustration.length >= 4 && !formData.biggestFrustration.includes(option)} className="mr-2" data-id="element-2270" />
                        <span style={{
                    color: '#333333'
                  }} data-id="element-2271">
                          {option}
                        </span>
                      </label>)}
                  </div>
                  <p className="text-sm mt-1" style={{
                color: '#666'
              }} data-id="element-2272">
                    Selected: {formData.biggestFrustration.length}/4
                  </p>
                </div>

                <div data-id="element-2273">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2274">
                    If you could walk away from this class with ONE thing fully
                    done, what would it be? * (Pick only 1)
                  </label>
                  <select name="oneThingToWalkAway" value={formData.oneThingToWalkAway} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2275">
                    <option value="" data-id="element-2276">Select one...</option>
                    <option value="My first automated workflow" data-id="element-2277">
                      My first automated workflow
                    </option>
                    <option value="My first AI-created digital product" data-id="element-2278">
                      My first AI-created digital product
                    </option>
                    <option value="My personal AI assistant set up" data-id="element-2279">
                      My personal AI assistant set up
                    </option>
                    <option value="My business processes automated" data-id="element-2280">
                      My business processes automated
                    </option>
                    <option value="My AI portfolio built" data-id="element-2281">
                      My AI portfolio built
                    </option>
                    <option value="My AI content creation system" data-id="element-2282">
                      My AI content creation system
                    </option>
                    <option value="My first AI-powered income stream" data-id="element-2283">
                      My first AI-powered income stream
                    </option>
                    <option value="My resume/LinkedIn profile optimized with AI" data-id="element-2284">
                      My resume/LinkedIn profile optimized with AI
                    </option>
                    <option value="My business marketing system automated" data-id="element-2285">
                      My business marketing system automated
                    </option>
                    <option value="Clarity and confidence using AI tools" data-id="element-2286">
                      Clarity and confidence using AI tools
                    </option>
                    <option value="A full 30-day action plan I can follow" data-id="element-2287">
                      A full 30-day action plan I can follow
                    </option>
                    <option value="Not sure — I want recommendations" data-id="element-2288">
                      Not sure — I want recommendations
                    </option>
                  </select>
                </div>

                <button type="submit" className="w-full py-4 rounded-md font-bold text-white text-lg transition-all hover:opacity-90" style={{
              backgroundColor: '#0B1F3F'
            }} data-id="element-2289">
                  Next →
                </button>
              </> : <>
                <h2 className="text-2xl font-bold mb-6" style={{
              color: '#0B1F3F'
            }} data-id="element-2290">
                  Buying Power & Learning Style
                </h2>

                <div data-id="element-2291">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2292">
                    Interest in full practical masterclass *
                  </label>
                  <select name="interestInMasterclass" value={formData.interestInMasterclass} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2293">
                    <option value="" data-id="element-2294">Select...</option>
                    <option value="Very Interested" data-id="element-2295">Very Interested</option>
                    <option value="Somewhat Interested" data-id="element-2296">
                      Somewhat Interested
                    </option>
                    <option value="Not Interested" data-id="element-2297">Not Interested</option>
                  </select>
                </div>

                <div data-id="element-2298">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2299">
                    Price range you would consider? * (₦100,000–₦250,000)
                  </label>
                  <select name="priceWillingness" value={formData.priceWillingness} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2300">
                    <option value="" data-id="element-2301">Select...</option>
                    <option value="₦100,000 – ₦130,000" data-id="element-2302">
                      ₦100,000 – ₦130,000
                    </option>
                    <option value="₦130,000 – ₦160,000" data-id="element-2303">
                      ₦130,000 – ₦160,000
                    </option>
                    <option value="₦160,000 – ₦190,000" data-id="element-2304">
                      ₦160,000 – ₦190,000
                    </option>
                    <option value="₦190,000 – ₦220,000" data-id="element-2305">
                      ₦190,000 – ₦220,000
                    </option>
                    <option value="₦220,000 – ₦250,000" data-id="element-2306">
                      ₦220,000 – ₦250,000
                    </option>
                    <option value="I can pay in installments" data-id="element-2307">
                      I can pay in installments
                    </option>
                    <option value="I can only join if there is a scholarship/discount" data-id="element-2308">
                      I can only join if there is a scholarship/discount
                    </option>
                  </select>
                </div>

                <div data-id="element-2309">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2310">
                    What would make you confidently invest in a premium hands-on
                    program? * (Choose at most 2)
                  </label>
                  <div className="space-y-2" data-id="element-2311">
                    {['Step-by-step practical learning', 'Real-life projects I can use immediately', 'A mentor or expert I can ask questions', 'Templates, tools & resources included', 'A clear promise of skill mastery', 'Proof that others got results', 'Certificate + portfolio', 'Live sessions + recordings', 'Community support + accountability', 'Money-back guarantee', 'A clear path to earning with AI', 'Flexible payment options'].map(option => <label key={option} className="flex items-center" data-id="element-2312">
                        <input type="checkbox" name="investmentFactor" value={option} checked={formData.investmentFactor.includes(option)} onChange={handleFormChange} disabled={formData.investmentFactor.length >= 2 && !formData.investmentFactor.includes(option)} className="mr-2" data-id="element-2313" />
                        <span style={{
                    color: '#333333'
                  }} data-id="element-2314">
                          {option}
                        </span>
                      </label>)}
                  </div>
                  <p className="text-sm mt-1" style={{
                color: '#666'
              }} data-id="element-2315">
                    Selected: {formData.investmentFactor.length}/2
                  </p>
                </div>

                <div data-id="element-2316">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2317">
                    Do you want to use this skill to earn money? *
                  </label>
                  <select name="monetizationIntent" value={formData.monetizationIntent} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2318">
                    <option value="" data-id="element-2319">Select...</option>
                    <option value="Yes" data-id="element-2320">Yes</option>
                    <option value="No" data-id="element-2321">No</option>
                    <option value="Maybe" data-id="element-2322">Maybe</option>
                  </select>
                </div>

                <div data-id="element-2323">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2324">
                    Audience you plan to serve? * (Choose 2-3)
                  </label>
                  <div className="space-y-2" data-id="element-2325">
                    {['Small business owners', 'Students / young people', 'Creatives (writers, designers, content creators)', 'NGOs / nonprofits', 'Coaches / consultants', 'Corporate teams', 'Schools / teachers', 'E-commerce businesses', 'Real estate', 'Health & wellness', 'Churches / ministries', 'Anyone who needs digital transformation', 'Not sure yet — I need help choosing'].map(option => <label key={option} className="flex items-center" data-id="element-2326">
                        <input type="checkbox" name="audienceToServe" value={option} checked={formData.audienceToServe.includes(option)} onChange={handleFormChange} disabled={formData.audienceToServe.length >= 3 && !formData.audienceToServe.includes(option)} className="mr-2" data-id="element-2327" />
                        <span style={{
                    color: '#333333'
                  }} data-id="element-2328">
                          {option}
                        </span>
                      </label>)}
                  </div>
                  <p className="text-sm mt-1" style={{
                color: '#666'
              }} data-id="element-2329">
                    Selected: {formData.audienceToServe.length}/3
                  </p>
                </div>

                <div data-id="element-2330">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2331">
                    Monthly income goal using AI-assisted skills *
                  </label>
                  <input type="text" name="monthlyIncomeGoal" value={formData.monthlyIncomeGoal} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2332" />
                </div>

                <div data-id="element-2333">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2334">
                    Preferred class style *
                  </label>
                  <select name="preferredClassStyle" value={formData.preferredClassStyle} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2335">
                    <option value="" data-id="element-2336">Select...</option>
                    <option value="Live" data-id="element-2337">Live</option>
                    <option value="Recorded" data-id="element-2338">Recorded</option>
                    <option value="Hybrid" data-id="element-2339">Hybrid</option>
                  </select>
                </div>

                <div data-id="element-2340">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2341">
                    Preferred Class Time * (Choose 2)
                  </label>
                  <div className="space-y-2" data-id="element-2342">
                    {['Weekday mornings', 'Weekday afternoons', 'Weekday evenings', 'Saturday mornings', 'Saturday afternoons', 'Saturday evenings', 'Sunday afternoon', 'Fully online & flexible (self-paced + live support)'].map(option => <label key={option} className="flex items-center" data-id="element-2343">
                        <input type="checkbox" name="preferredClassTime" value={option} checked={formData.preferredClassTime.includes(option)} onChange={handleFormChange} disabled={formData.preferredClassTime.length >= 2 && !formData.preferredClassTime.includes(option)} className="mr-2" data-id="element-2344" />
                        <span style={{
                    color: '#333333'
                  }} data-id="element-2345">
                          {option}
                        </span>
                      </label>)}
                  </div>
                  <p className="text-sm mt-1" style={{
                color: '#666'
              }} data-id="element-2346">
                    Selected: {formData.preferredClassTime.length}/2
                  </p>
                </div>

                <div data-id="element-2347">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2348">
                    How do you prefer to practice? * (Choose 2)
                  </label>
                  <div className="space-y-2" data-id="element-2349">
                    {['Guided step-by-step exercises', 'Real project challenges', 'Assignments with feedback', 'Interactive live sessions', 'Solo practice following templates', 'Group practice / paired learning', 'Watching video tutorials', 'Doing it myself with occasional support', 'A combination of everything'].map(option => <label key={option} className="flex items-center" data-id="element-2350">
                        <input type="checkbox" name="practicePreference" value={option} checked={formData.practicePreference.includes(option)} onChange={handleFormChange} disabled={formData.practicePreference.length >= 2 && !formData.practicePreference.includes(option)} className="mr-2" data-id="element-2351" />
                        <span style={{
                    color: '#333333'
                  }} data-id="element-2352">
                          {option}
                        </span>
                      </label>)}
                  </div>
                  <p className="text-sm mt-1" style={{
                color: '#666'
              }} data-id="element-2353">
                    Selected: {formData.practicePreference.length}/2
                  </p>
                </div>

                <div data-id="element-2354">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2355">
                    If a payment plan would help you join faster *
                  </label>
                  <select name="paymentPlanHelp" value={formData.paymentPlanHelp} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2356">
                    <option value="" data-id="element-2357">Select...</option>
                    <option value="Yes" data-id="element-2358">Yes</option>
                    <option value="No" data-id="element-2359">No</option>
                  </select>
                </div>

                <div data-id="element-2360">
                  <label className="block mb-2 font-medium" style={{
                color: '#333333'
              }} data-id="element-2361">
                    Permission to receive updates on upcoming advanced
                    masterclasses *
                  </label>
                  <select name="permissionForUpdates" value={formData.permissionForUpdates} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
                border: '2px solid #E5E5E5'
              }} data-id="element-2362">
                    <option value="" data-id="element-2363">Select...</option>
                    <option value="Yes" data-id="element-2364">Yes</option>
                    <option value="No" data-id="element-2365">No</option>
                  </select>
                </div>

                <div className="flex gap-4" data-id="element-2366">
                  <button type="button" onClick={() => setFormStep(1)} className="flex-1 py-4 rounded-md font-bold transition-all hover:opacity-90" style={{
                backgroundColor: '#E5E5E5',
                color: '#333333'
              }} data-id="element-2367">
                    ← Back
                  </button>
                  <button type="submit" className="flex-1 py-4 rounded-md font-bold text-white transition-all hover:opacity-90" style={{
                backgroundColor: '#F4B400'
              }} data-id="element-2368">
                    Submit & Join WhatsApp Group
                  </button>
                </div>
              </>}
          </form>
        </div>
      </div>;
  }
  return <>
      <PaystackScript data-id="element-2369" />
      <div className="min-h-screen" style={{
      backgroundColor: '#F9F9F9'
    }} data-id="element-2370">
        {/* Hero Section with Floating Comments */}
        <section className="relative py-20 overflow-hidden" data-id="element-2371">
          <div className="absolute inset-0 z-0" data-id="element-2372">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bNxF5qHdCS6UJLX4hcirCA/IMG_7209.jpg" alt="AI Power Bundle" className="w-full h-full object-cover grayscale opacity-20" data-id="element-2373" />
          </div>

          {/* Floating Comments - Left Side */}
          <div className="absolute left-4 md:left-8 top-32 z-20 space-y-6 hidden md:block" data-id="element-2374">
            <div className="p-4 rounded-lg shadow-lg max-w-[220px] animate-float-left" style={{
            backgroundColor: '#F4B400',
            color: '#FFFFFF',
            animationDelay: '0s'
          }} data-id="element-2375">
              <p className="font-bold text-sm mb-1" data-id="element-2376">Adebayo Okonkwo ✓</p>
              <p className="text-xs" data-id="element-2377">
                This transformed how I work. AI is no longer intimidating!
              </p>
            </div>
            <div className="p-4 rounded-lg shadow-lg max-w-[220px] animate-float-left" style={{
            backgroundColor: '#F4B400',
            color: '#FFFFFF',
            animationDelay: '1s'
          }} data-id="element-2378">
              <p className="font-bold text-sm mb-1" data-id="element-2379">Chidinma Nwosu ✓</p>
              <p className="text-xs" data-id="element-2380">
                Finally, AI skills I can actually use in my business!
              </p>
            </div>
          </div>

          {/* Floating Comments - Right Side */}
          <div className="absolute right-4 md:right-8 top-32 z-20 space-y-6 hidden md:block" data-id="element-2381">
            <div className="p-4 rounded-lg shadow-lg max-w-[220px] animate-float-right" style={{
            backgroundColor: '#F4B400',
            color: '#FFFFFF',
            animationDelay: '0.5s'
          }} data-id="element-2382">
              <p className="font-bold text-sm mb-1" data-id="element-2383">Oluwaseun Adeyemi ✓</p>
              <p className="text-xs" data-id="element-2384">
                Cut my content creation time in half. Game changer!
              </p>
            </div>
            <div className="p-4 rounded-lg shadow-lg max-w-[220px] animate-float-right" style={{
            backgroundColor: '#F4B400',
            color: '#FFFFFF',
            animationDelay: '1.5s'
          }} data-id="element-2385">
              <p className="font-bold text-sm mb-1" data-id="element-2386">Ngozi Okafor ✓</p>
              <p className="text-xs" data-id="element-2387">
                Best investment I made this year. Simple and actionable!
              </p>
            </div>
          </div>

          <div className="container mx-auto px-4 relative z-10" data-id="element-2388">
            <div className="max-w-4xl mx-auto text-center" data-id="element-2389">
              <h1 className="text-4xl md:text-6xl font-bold mb-6" style={{
              color: '#0B1F3F'
            }} data-id="element-2390">
                The 2026 AI Power Bundle for Professionals
              </h1>
              <p className="text-xl md:text-2xl mb-8" style={{
              color: '#333333'
            }} data-id="element-2391">
                Everything you need to master AI for work, content, brand, and
                productivity — in one actionable bundle
              </p>
              <button onClick={initializePayment} className="px-8 py-4 rounded-lg font-bold text-white text-lg transition-all hover:opacity-90 shadow-lg" style={{
              backgroundColor: '#0B1F3F'
            }} data-id="element-2392">
                Grab a Copy for ₦5,000
              </button>
            </div>
          </div>
        </section>

        {/* Sales Copy Section - Freytag Storytelling */}
        <section className="py-16" style={{
        backgroundColor: '#FFFFFF'
      }} data-id="element-2393">
          <div className="container mx-auto px-4" data-id="element-2394">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-2395">
              <p className="text-lg md:text-xl mb-6" style={{
              color: '#333333'
            }} data-id="element-2396">
                <strong style={{
                color: '#0B1F3F'
              }} data-id="element-2397">
                  You're watching everyone else leverage AI
                </strong>{' '}
                while you're still stuck doing everything manually. Your
                competitors are creating content in minutes. Your peers are
                automating their workflows. And you? You're drowning in tasks
                that AI could handle in seconds.
              </p>
              <p className="text-lg md:text-xl mb-6" style={{
              color: '#333333'
            }} data-id="element-2398">
                <strong style={{
                color: '#0B1F3F'
              }} data-id="element-2399">
                  The pressure is real.
                </strong>{' '}
                Clients expect faster turnarounds. Your business demands more
                efficiency. Your personal brand needs consistent content. But
                every "AI tutorial" you find is either too technical, too
                expensive, or too time-consuming to implement.
              </p>
              <p className="text-lg md:text-xl mb-6" style={{
              color: '#333333'
            }} data-id="element-2400">
                <strong style={{
                color: '#0B1F3F'
              }} data-id="element-2401">
                  What if you could master AI in one weekend?
                </strong>{' '}
                Not with complex coding or expensive courses — but with simple,
                copy-paste prompts and tools designed specifically for Nigerian
                professionals, educators, and business owners like you.
              </p>
              <p className="text-lg md:text-xl mb-6" style={{
              color: '#333333'
            }} data-id="element-2402">
                <strong style={{
                color: '#1AB9C8'
              }} data-id="element-2403">
                  The 2026 AI Power Bundle
                </strong>{' '}
                gives you everything: AI skills that matter, personal branding
                strategies, time-saving tools, ready-to-use prompts for content
                and photos — all for less than the cost of lunch.
              </p>
              <p className="text-lg md:text-xl font-bold" style={{
              color: '#0B1F3F'
            }} data-id="element-2404">
                Stop watching from the sidelines. Start leading with AI — today.
              </p>
            </div>
          </div>
        </section>

        {/* What's Inside Section */}
        <section className="py-16" style={{
        backgroundColor: '#F9F9F9'
      }} data-id="element-2405">
          <div className="container mx-auto px-4" data-id="element-2406">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" style={{
            color: '#0B1F3F'
          }} data-id="element-2407">
              What's Inside the Ebook
            </h2>
            <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-2408">
              {[{
              icon: <Star size={24} data-id="element-2409" />,
              title: 'AI Skills Every Professional Must Learn in 2025',
              desc: 'Stay ahead of the curve and make yourself indispensable'
            }, {
              icon: <TrendingUp size={24} data-id="element-2410" />,
              title: 'How to Build a Personal Brand With AI in 7 Steps',
              desc: 'Position yourself as an expert and attract opportunities'
            }, {
              icon: <Zap size={24} data-id="element-2411" />,
              title: 'AI Tools That Will Cut Your Work Time in Half',
              desc: 'Work faster, smarter, and more efficiently'
            }, {
              icon: <Check size={24} data-id="element-2412" />,
              title: '10 AI Prompts for Content Generation',
              desc: 'Create content instantly with professional tone'
            }, {
              icon: <Check size={24} data-id="element-2413" />,
              title: '10 AI Prompts for Your Photo Editing',
              desc: 'Edit and enhance images like a pro without software'
            }].map((item, i) => <div key={i} className="p-6 rounded-lg transition-all hover:shadow-lg" style={{
              border: '2px solid #1AB9C8'
            }} data-id="element-2414">
                  <div className="flex items-start gap-4" data-id="element-2415">
                    <div className="p-3 rounded-full" style={{
                  backgroundColor: '#1AB9C8',
                  color: '#FFFFFF'
                }} data-id="element-2416">
                      {item.icon}
                    </div>
                    <div data-id="element-2417">
                      <h3 className="text-xl font-bold mb-2" style={{
                    color: '#0B1F3F'
                  }} data-id="element-2418">
                        {item.title}
                      </h3>
                      <p style={{
                    color: '#333333'
                  }} data-id="element-2419">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* Urgency Section */}
        <section className="py-16" style={{
        backgroundColor: '#F4B400'
      }} data-id="element-2420">
          <div className="container mx-auto px-4" data-id="element-2421">
            <div className="max-w-3xl mx-auto text-center" data-id="element-2422">
              <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{
              color: '#0B1F3F'
            }} data-id="element-2423">
                Limited Time Offer!
              </h2>
              <p className="text-xl mb-8" style={{
              color: '#333333'
            }} data-id="element-2424">
                Grab it today for ₦5,000 — price increases to ₦25,000 by the end
                of 2025. Secure your copy while it's still affordable!
              </p>
              <button onClick={initializePayment} className="px-8 py-4 rounded-lg font-bold text-lg transition-all hover:opacity-90 shadow-lg" style={{
              backgroundColor: '#0B1F3F',
              color: '#FFFFFF'
            }} data-id="element-2425">
                Grab Your Copy Now
              </button>
            </div>
          </div>
        </section>

        {/* Upsell Section */}
        <section className="py-16" style={{
        backgroundColor: '#FFFFFF'
      }} data-id="element-2426">
          <div className="container mx-auto px-4" data-id="element-2427">
            <div className="max-w-3xl mx-auto p-8 rounded-lg" style={{
            border: '2px solid #1AB9C8'
          }} data-id="element-2428">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 text-center" style={{
              color: '#0B1F3F'
            }} data-id="element-2429">
                Ready to Go Deeper?
              </h2>
              <p className="text-lg mb-6" style={{
              color: '#333333'
            }} data-id="element-2430">
                Loved the bundle? Join our full practical masterclass where
                you'll create your own AI-assisted website, automation systems,
                content strategies, and personal brand framework. Limited seats,
                hands-on guidance, and 50+ ready-to-use prompts.
              </p>
              <div className="text-center" data-id="element-2431">
                <Link to="/ai-masterclass" data-id="element-2432">
                  <button className="px-8 py-4 rounded-lg font-bold text-white text-lg transition-all hover:opacity-90" style={{
                  backgroundColor: '#1AB9C8'
                }} data-id="element-2433">
                    Learn More About Masterclass
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <style data-id="element-2434">{`
          @keyframes float-left {
            0%, 100% { transform: translateY(0px) translateX(0px); }
            50% { transform: translateY(-15px) translateX(5px); }
          }
          @keyframes float-right {
            0%, 100% { transform: translateY(0px) translateX(0px); }
            50% { transform: translateY(-15px) translateX(-5px); }
          }
          .animate-float-left {
            animation: float-left 4s ease-in-out infinite;
          }
          .animate-float-right {
            animation: float-right 4s ease-in-out infinite;
          }
        `}</style>
      </div>
    </>;
};